import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-how-it-works-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './how-it-works-section.component.html',
  styleUrls: ['./how-it-works-section.component.scss']
})
export class HowItWorksSectionComponent {
  migrationSteps = [
    { title: 'Import your members', description: 'Bring in your existing member data quickly and securely.' },
    { title: 'Customize your setup', description: 'Apply your branding, configure workflows, and tailor the experience to your organization—without custom development.' },
    { title: 'Give members access on web and mobile', description: 'Use your branded web experience and mobile tools so members can stay connected anywhere.' },
    { title: 'Go live with confidence', description: 'Start managing renewals, communication, events, and payments on connected member records from day one.' }
  ];
}
